module.exports = __webpack_public_path__ + "static/media/city_green_bg.937ebf88.svg";